// @ts-nocheck
import { createContext, Dispatch, SetStateAction } from 'react'

import { CustomFormQuestionError, CustomFormViewerProps } from 'components/tools/CustomForm/types'

export type CustomFormViewerManagerContextType = CustomFormViewerProps & {
  setErrorOnQuestion: (question: CustomFormQuestion, errorMessage: string) => void
  removeErrorFromQuestion: (questionSlug?: string) => void
  thisQuestionHasError: (questionSlug?: string) => { hasError: boolean; question: CustomFormQuestionError }
  questionErrors: CustomFormQuestionError[]
  setQuestionErrors: Dispatch<SetStateAction<CustomFormQuestionError[]>>
}

const defaultValues = {
  onSubmit: async () => {},
  setErrorOnQuestion: () => {},
  removeErrorFromQuestion: () => {},
  thisQuestionHasError: () => {},
  questionErrors: [],
  setQuestionErrors: () => {},
  questions: [],
  formMethods: {},
  _uploadFile: async () => {},
  formId: undefined,
}

const CustomFormViewerManagerContext = createContext<CustomFormViewerManagerContextType>(defaultValues)

export default CustomFormViewerManagerContext
